import { DateTime } from 'luxon';
import { FULFILLMENT_TYPE, STATUS_CODE } from '../../constants/status';
var daysInOrder = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
];
var dayLabels = {
    monday: 'Mon',
    tuesday: 'Tue',
    wednesday: 'Wed',
    thursday: 'Thu',
    friday: 'Fri',
    saturday: 'Sat',
    sunday: 'Sun',
};
var formatTime = function (time) {
    var dt = DateTime.fromFormat(time, 'HH:mm');
    if (!dt.isValid)
        return null;
    // Format as h:mm a and remove ":00" minutes if zero
    return dt.toFormat('h:mm a').replace(':00', '');
};
export var formatCurbsidePickupHours = function (pickupHours) {
    // Return null if pickupHours is not provided
    if (!pickupHours)
        return null;
    // Build daily hour ranges
    var dailyHourRanges = daysInOrder.map(function (day) {
        var _a, _b;
        var open = (_a = pickupHours[day]) === null || _a === void 0 ? void 0 : _a.open;
        var close = (_b = pickupHours[day]) === null || _b === void 0 ? void 0 : _b.close;
        // If both open and close hours are present, return a range string, otherwise return null
        return open && close ? "".concat(open, "-").concat(close) : null;
    });
    // If all days are missing hours (all entries are null), return null
    if (dailyHourRanges.every(function (range) { return range === null; }))
        return null;
    // Check if all days have valid hours (i.e., not null)
    var allDaysPresent = dailyHourRanges.every(function (range) { return range !== null; });
    // If all valid days share the same hours (ignoring nulls), return a simplified output
    var allDaysHaveSameHours = allDaysPresent &&
        dailyHourRanges.every(function (range) { return range === dailyHourRanges[0]; });
    // If all days have the same hours, we return a single time range
    if (allDaysHaveSameHours && dailyHourRanges[0]) {
        var _a = dailyHourRanges[0].split('-'), open_1 = _a[0], close_1 = _a[1];
        var formattedOpenTime = formatTime(open_1);
        var formattedCloseTime = formatTime(close_1);
        if (!formattedOpenTime || !formattedCloseTime) {
            return null;
        }
        return "".concat(formattedOpenTime, " \u2013 ").concat(formattedCloseTime);
    }
    // Array to store the grouped ranges
    var groupedRanges = [];
    var groupStartIndex = null;
    dailyHourRanges.forEach(function (currentDayRange, index) {
        if (currentDayRange) {
            // Start a new group if this is the first day with a valid time range
            if (groupStartIndex === null) {
                groupStartIndex = index;
            }
            // Check if the next day's hours are different or if it's the last day of the week
            var nextDayRange = dailyHourRanges[index + 1];
            var isLastDayOfWeek = index === dailyHourRanges.length - 1;
            var isGroupEnd = isLastDayOfWeek ||
                nextDayRange !== currentDayRange ||
                nextDayRange === null;
            // If the current group ends (either at the end of the week or because hours change), push the group to the array
            if (isGroupEnd && groupStartIndex !== null) {
                groupedRanges.push({
                    startIndex: groupStartIndex,
                    endIndex: index,
                    hours: currentDayRange,
                });
                // Reset group start index for the next group
                groupStartIndex = null;
            }
        }
    });
    // Format and return the grouped ranges into a string
    var formattedHours = groupedRanges
        .map(function (group) {
        var startIndex = group.startIndex, endIndex = group.endIndex, hours = group.hours;
        var _a = hours.split('-'), open = _a[0], close = _a[1];
        var formattedOpenTime = formatTime(open);
        var formattedCloseTime = formatTime(close);
        // Skip this group if either time is invalid
        if (!formattedOpenTime || !formattedCloseTime) {
            return null;
        }
        var startLabel = dayLabels[daysInOrder[startIndex]];
        var endLabel = dayLabels[daysInOrder[endIndex]];
        var dayRange = startIndex === endIndex ? startLabel : "".concat(startLabel, "\u2013").concat(endLabel);
        return "".concat(dayRange, ": ").concat(formattedOpenTime, " \u2013 ").concat(formattedCloseTime);
    })
        .filter(Boolean)
        .join(' | ');
    return formattedHours || null;
};
export var isCurbsidePickupEligible = function (fulfillmentGroup) {
    var _a;
    if (!fulfillmentGroup)
        return false;
    var fulfillmentType = fulfillmentGroup.fulfillmentType, lineItems = fulfillmentGroup.lineItems, storePickup = fulfillmentGroup.storePickup;
    var lineItemStatus = (_a = lineItems === null || lineItems === void 0 ? void 0 : lineItems[0]) === null || _a === void 0 ? void 0 : _a.statusCode;
    var eligibleFulfillmentTypes = [
        FULFILLMENT_TYPE.BOPIS,
        FULFILLMENT_TYPE.BOSS,
    ];
    var eligibleStatuses = [
        STATUS_CODE.PREPARING_FOR_PICKUP,
        STATUS_CODE.READY_FOR_PICKUP,
    ];
    return ((storePickup === null || storePickup === void 0 ? void 0 : storePickup.isCurbsidePickupAvailable) &&
        eligibleFulfillmentTypes.includes(fulfillmentType) &&
        eligibleStatuses.includes(lineItemStatus) &&
        !(storePickup === null || storePickup === void 0 ? void 0 : storePickup.IsInLocker));
};
